<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="form_wrap">
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">
              上传人物图片
              <el-tooltip class="item" effect="dark"
                          placement="top-start">
                <template v-slot:content>
                  <div>
                    <p style="line-height: 1.4">以在图形中更改最多1张人脸的唇色。</p>
                  </div>
                </template>
                <img style="width: 16px;height: 16px;margin-left: 6px" src="../img/032.png" alt="">
              </el-tooltip>
            </div>
          </div>
          <div class="Reference_image" v-loading="upmjloading"
               element-loading-background="rgba(122, 122, 122, 0.8)">
            <el-upload
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/upload/?fdir=mj_tool'"
                :show-file-list="false"
                accept="image/jpeg, image/png, image/bmp"
                :on-success="UpdataSuccess"
                :before-upload="beforeUpload"
                multiple>
              <div v-if="form.data.iw_url" class="yesUpload">
                <img :src="form.data.iw_url" alt="" class="yesUpload_img">
                <div class="yesUpload_icon" @click.stop="form.data.iw_url=''">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过8MB</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">唇色（选择&展示）</div>
          </div>
          <div class="selectColor">
            <el-color-picker
                v-model="color1"
                @change="select_color(color1)"
                color-format="rgb"
                show-alpha
            ></el-color-picker>
            <div class="colorBox" >
              <div :style="{'background-color': color1}">

              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div class="primary_button" @click="sendMsg" v-loading="sending">提交任务 <span>（消耗2积分）</span></div>
    </div>

    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      sending: false,
      upload_img_url: "",
      form: {
        data: {
          iw_url: '',
          lip_color_infos:"[{\"rgba\":{\"r\":198,\"g\":74,\"b\":85,\"a\":80}}]"// 美颜所有人脸 最好不要超过10个人脸
        },
        mj_tool: '',
      },
      fileApi: FILE_API_SERVER,
      isWxEnv: false,
      upmjloading: false,

      arrange: '',
      relation: '',
      toolList: [
        {
          title: '图片编辑', list: [
            {
              id: 1,
              relation: 0,
              name: '极速高清无损放大',
              guide: '无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题。',
              img: require('../img/magnify.png'),
              title: '无损放大',
              mj_tool: 'Upscaler',
            },

            {
              id: 2,
              relation: 0,
              name: '黑白图像上色',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('../img/colour.png'),
              title: '黑白上色',
              mj_tool: 'Colorize',
            },
            {
              id: 3,
              relation: 0,
              name: '图像清晰度增强',
              guide: '利用Ai技术，智能识别图像主体以消除模糊，增强对比度和颜色，获得更清晰、更生动的视觉效果。',
              img: require('../img/repair.png'),
              title: '清晰增强',
              mj_tool: 'SharpnessEnhancement',
            },
            {
              id: 4,
              relation: 0,
              name: '图像风格转换',
              guide: '您可以将图像转换为卡通、铅笔、彩色铅笔或哥特式油画等多种风格。',
              img: require('../img/cartoon.png'),
              title: '风格转换',
              mj_tool: 'Painting',

            },

          ],
        },
        {
          title: '电商设计', list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除',
              guide: '智能地识别图像的主体，将其视为前景并自动去除背景。适用于各种场景中的人物、动物等。',
              img: require('../img/capture.png'),
              title: '背景移除',
              mj_tool: 'BackgroundRemoval',
            },

          ],
        },
        {
          title: '创意应用', id: 3, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              guide: '它能够准确检测头部区域，一键裁剪并去除其他元素。',
              img: require('../img/expansion.png'),
              title: '头像提取',
              mj_tool: 'HeadExtraction',

            },

          ],
        },
        {
          title: 'AI变美', relation: 3, list: [
            {
              id: 1,
              relation: 3,
              name: '照片一键美颜',
              title: '照片一键美颜',
              mj_tool: 'oneClickBeautyTransformation',
              guide: '利用AI技术，实现完整的肖像增强，包括皮肤平滑、美白、脸部瘦身等，以达到自然的外观',
              img: require('../img/beautify1.webp'),
              points: 1,
            },
            {
              id: 2,
              relation: 3,
              name: '人物动漫化',
              title: '人物动漫化',
              mj_tool: 'characterAnime',
              guide: '利用先进的AI技术将完整图像或照片转化为卡通或动漫效果，非常适合创建卡通化照片和卡通风格的虚拟形象',
              img: require('../img/beautify2.webp'),
              points: 1,
            },
            {
              id: 3,
              relation: 3,
              name: '人脸滤镜',
              title: '人脸滤镜',
              mj_tool: 'emitFacefilter',
              guide: '智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果',
              img: require('../img/beautify3.webp'),
              points: 1,
            },
            {
              id: 4,
              relation: 3,
              name: '人脸模糊(打码)',
              title: '人脸模糊(打码)',
              mj_tool: 'emitBlurredfaces',
              guide: '利用先进的AI技术，智能识别人脸区域，一键模糊人脸，轻松保护隐私，提升图像安全性',
              img: require('../img/beautify4.webp'),
              points: 1,
            },
            {
              id: 5,
              relation: 3,
              name: '发型编辑',
              title: '发型编辑',
              mj_tool: 'emitHairstyleeditor',
              guide: '能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求',
              img: require('../img/beautify5.webp'),
              points: 1,
            },
            {
              id: 6,
              relation: 3,
              name: '表情编辑',
              title: '表情编辑',
              mj_tool: 'emitEmotioneditor',
              guide: '无论是闭嘴微笑、露齿笑、嘟嘴、还是耍酷或悲伤等十多种表情，您都可以轻松生成自然逼真的效果',
              img: require('../img/beautify6.webp'),
              points: 1,
            },
            {
              id: 7,
              relation: 3,
              name: '年龄・性別变换',
              title: '年龄・性別变换',
              mj_tool: 'emitFaceattributeediting',
              guide: '采用先进的AI技术，智能识别人脸，实现从15岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('../img/beautify7.webp'),
              points: 1,
            },
            {
              id: 8,
              relation: 3,
              name: '人脸美颜',
              title: '人脸美颜',
              mj_tool: 'emitFacebeauty',
              guide: '拥有美白和光滑皮肤等美化特性，以及面部塑形。此外，它还提供了多种滤镜，以增强您的图像并增添艺术气息。',
              img: require('../img/beautify8.webp'),
              points: 1,
            },
            {
              id: 9,
              relation: 3,
              name: '人脸美妆',
              title: '人脸美妆',
              mj_tool: 'emitFacemakeup',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../img/beautify9.webp'),
              points: 1,
            },
            {
              id: 10,
              relation: 3,
              name: '唇色变换器',
              title: '唇色变换器',
              mj_tool: 'emitLipscolorchanger',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../img/beautify10.webp'),
              points: 1,
            },
            {
              id: 11,
              relation: 3,
              name: '人脸修复增强',
              title: '人脸修复增强',
              mj_tool: 'emitEnhanceface',
              guide: '自动去除图像中的模糊部分，提升脸部的清晰度和细节。通过AI处理，您可以轻松优化面部图像的质量，使其更加清晰、自然',
              img: require('../img/beautify11.webp'),
              points: 1,
            },
          ],
        },

      ],

      color1:'rgba(198, 74, 85, 0.8)',
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    }
  },
  created() {
    this.arrange = this.$route.query.arrange
    this.relation = this.$route.query.relation
    this.form.mj_tool = this.toolList[this.relation].list[this.arrange - 1].mj_tool
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.handleDocumentClick);
      let _form = this.getCache("formAdvanceParams") || ""
      if (_form) {
        this.form = JSON.parse(_form)
      }
    }, 100)
  },
  methods: {
    select_color(value) {
      console.log('value',value)
      // 解析颜色值
      const rgba = this.parseRgba(value);
      console.log('rgba',[rgba])
      // 转换为目标格式
      this.form.data.lip_color_infos = JSON.stringify([rgba]);
      console.log('this.form.lip_color_infos',this.form.lip_color_infos); // 打印结果
    },
    parseRgba(rgbaString) {
      console.log('rgbaString',rgbaString)
      // 使用正则表达式提取 rgba 值
      const regex = /rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d*(?:\.\d+)?)\)/;
      const match = rgbaString.match(regex);
      if (match) {
        return {
          rgba: {
            r: parseInt(match[1], 10),
            g: parseInt(match[2], 10),
            b: parseInt(match[3], 10),
            a: parseFloat(match[4])*100,
          },
        };
      }
      return null; // 如果格式不正确，返回 null
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },

    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },

    handleDocumentClick(event) {
      // 判断点击的区域是否是 container 元素或其子元素
      if (this.$refs.container && !this.$refs.container.contains(event.target)) {
        // 点击了除 container 以外的区域，执行相应操作
        this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
      }
    },
    getProfile() {
      this.$http.get(`${MAIN_URLROOT}/api/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    //发送消息
    sendMsg() {
      console.log(this.form)

      if (!this.checkLogin()) return
      if(!utils.setOptData(this.userInfo,'btn_aitool_create')){
          return
      }
      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (this.form.data.iw_url === '') {
        this.$message.warning('请上传图片')
        return
      }
      // return;
      // 同步请求
      this.submitQuestion(this.form);
    },
    submitQuestion(data, parent_msg_code, i) {
      this.sending = true;
      // 提交问题
      data.source = "pc";
      this.$http.post('/front/aimj/mjtools/', data).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          this.getProfile()
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              console.log('进入会员中心')
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    // 上传图片
    UpdataSuccess(res, file) {
      this.upmjloading = false
      if (res.data.error !== '') {
        this.$message.error(res.data.error)
        return
      }
      this.form.data.iw_url = res.data.file_full_url;
    },
    beforeUpload(file) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      const isLt3M = file.size / 1024 / 1024 < 5;
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const { width, height } = img;
          const isValidResolution =  width <= 2000 &&  height <= 2000;
          // const isValidResolution = width >= 100 && width <= 2000 && height >= 100 && height <= 2000;

          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
            reject({ isValidType: false });
            return
          }

          if (!isLt3M) {
            this.$message.error('上传文件大小不能超过 5MB!');
            reject({ isLt3M: false });
            return
          }

          if (!isValidResolution) {
            this.$message.error('图片分辨率需小于 2000x2000 像素!');
            // this.$message.error('图片分辨率需大于 100x100 像素且小于 2000x2000 像素!');
            reject({ isValidResolution: false });
            return
          }
          this.upmjloading = true

          resolve({ isValidType, isLt3M, isValidResolution, });
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({ isImageValid: false });
        };
      });
    },
  },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>


#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    flex: 1 1 0%;
    margin-bottom: 80px;

    .form_wrap {
      padding: 5px 15px 15px;
      height: 100%;
    }

    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;
          display: flex;
          align-items: center;
          line-height: 1;
          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      // 上传参考图
      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;
        box-sizing: border-box;

        .upload-demo {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }


        }
      }

      .selectColor{
        width: 100%;
        background-color:#2b2d31;
        display: flex;

        .colorBox{
          background-color: white;
          margin-left: 10px;
          width: 100%;
          height: 40px;
          div{
            width: 100%;
            height: 100%;
          }
        }
      }


    }
  }


  .bottom_area {
    position: fixed;
    bottom: 60px;
    left: 0;

    background-color: #2b2d31;
    height: 70px;
    width: 100%;
    padding: 0 30px;


    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;

      span {
        font-size: 12px;
      }
    }
  }
}


.model_list {
  display: flex;


  .model_item {
    border-radius: 6px;
    border: 2px solid #1d2027;
    position: relative;
    overflow: hidden;

    &.active {
      border-color: #5865f2;
    }

    img {
      border: none;
      width: 100%;
    }

    .model_title {
      position: absolute;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.73);
      height: 25px;
      font-size: 12px;
      left: 0;
      bottom: 0;
    }
  }

  .quality {
    display: flex;
    color: #fff;
    font-size: 14px;

    .quality_btn {
      border: 2px solid #393c43;
      border-radius: 3px;
      background-color: #1d2027;
      padding: 10px 20px;
      margin: 0 20px 0 0;
      cursor: pointer;
      flex: 1;
    }

    .quality_btns {
      border: 2px solid #5865f2;
      border-radius: 3px;
      background-color: #303245;
      padding: 10px 20px;
      margin: 0 20px 0 0;
      cursor: pointer;
      flex: 1;

    }

  }

}


.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
  }
}

/deep/ .el-loading-mask {
  background: none;
}
</style>